interface IconSchoolProps {
  active?: boolean;
}
export const IconSchoolBuilding = ({ active }: IconSchoolProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 21H21"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3C13.44 3.576 15.06 3.576 16.5 3V5.7C15.06 6.276 13.44 6.276 12 5.7V3Z"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5.69995V8.39995"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4998 8.3999H7.4998C5.6998 8.3999 4.7998 9.2999 4.7998 11.0999V20.9999H19.1998V11.0999C19.1998 9.2999 18.2998 8.3999 16.4998 8.3999Z"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.32227 12H18.6783"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.39111 12V21"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M11.9912 12V21"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M15.5908 12V21"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  );
};
